import { openOverlay, closeOverlay } from '../overlay/animate';

const searchForm = document.querySelector('.js-search');
const searchButtons = document.querySelectorAll('.js-open-search-btn');
const searchCloseButton = document.querySelector('.js-close-search-btn');

const handleSearchButtonClicked = (e) => {
    e.preventDefault();
    openOverlay(searchForm);
    e.currentTarget.setAttribute('aria-expanded', 'true');
};

const handleSearchCloseButtonClicked = (e) => {
    e.preventDefault();
    closeOverlay(searchForm);

    searchButtons.forEach((searchButton) => {
        searchButton.setAttribute('aria-expanded', 'false');
    });
};

const init = () => {
    if (searchButtons.length > 0) {
        searchButtons.forEach((searchButton) => {
            searchButton.addEventListener('click', handleSearchButtonClicked);
        });
    }

    if (searchCloseButton) searchCloseButton.addEventListener('click', handleSearchCloseButtonClicked);
};

export default init;
